import React from 'react';
import Button from '../../../components/ui/Button';

const RevealButton = ({ onClick, isRevealed, disabled }) => {
  return (
    <div className="mb-8 md:mb-10 lg:mb-12">
      <Button
        variant={isRevealed ? 'secondary' : 'default'}
        size="xl"
        fullWidth
        onClick={onClick}
        disabled={disabled || isRevealed}
        iconName={isRevealed ? 'CheckCircle' : 'Gift'}
        iconPosition="right"
        className="h-16 md:h-20 lg:h-24 text-lg md:text-xl lg:text-2xl font-heading font-bold shadow-xl hover:shadow-2xl transition-all duration-300"
      >
        {isRevealed ? 'İÇERİK GÖSTERİLİYOR' : 'BUGÜN NE VAR?'}
      </Button>
      
      {!isRevealed && (
        <p className="text-center mt-4 md:mt-5 lg:mt-6 text-sm md:text-base lg:text-lg text-muted-foreground">
          Günün sürprizini keşfetmek için tıkla!
        </p>
      )}
    </div>
  );
};

export default RevealButton;